import { motion } from "framer-motion";
import { SectionHead } from "./Reveal";
import { EASE } from "@/lib/site";

const ITEMS = [
  { t: "Serramenti", d: "Finestre, portefinestre e porte interne in legno, alluminio e PVC ad alto isolamento.", img: "/img/p6.jpg", span: "lg:col-span-7" },
  { t: "Pavimenti", d: "Parquet in rovere, spina italiana e ungherese, gres effetto marmo e pietra naturale.", img: "/img/p5.jpg", span: "lg:col-span-5" },
  { t: "Rivestimenti", d: "Marmi, grandi lastre ceramiche e mosaici per bagni, cucine e pareti d'arredo.", img: "/img/p3.jpg", span: "lg:col-span-5" },
  { t: "Rubinetteria", d: "Miscelatori, soffioni e sanitari sospesi in finiture ottone, nero opaco e cromo.", img: "/img/p4.jpg", span: "lg:col-span-7" },
  { t: "Arredamento", d: "Cucine, mobili su misura, armadi, mobili bagno e complementi d'arredo per completare la casa chiavi in mano.", img: "/img/arredo.jpg", span: "lg:col-span-12" },
];

const Card = ({ item, i }) => (
  <motion.article data-testid={`supply-card-${i}`}
    initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1.1, delay: (i % 2) * 0.12, ease: EASE }}
    className={`group relative h-[420px] md:h-[480px] overflow-hidden ${item.span}`}>
    <img src={item.img} alt={item.t} loading="lazy"
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-110" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0e] via-[#0d0d0e]/40 to-transparent" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,transparent_0%,rgba(13,13,14,0.55)_70%)] opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
    <div className="absolute inset-x-0 bottom-0 p-8 md:p-10">
      <span className="label">Fornitura e posa · 0{i + 1}</span>
      <h3 className="mt-3 font-display text-4xl md:text-5xl font-light text-[#f4f1ea]">{item.t}</h3>
      <p className="mt-3 max-w-md text-sm md:text-base text-[#d8d2c6] leading-relaxed">{item.d}</p>
      <span className="mt-6 block h-px w-16 bg-[#d4a73c] origin-left transition-transform duration-700 group-hover:scale-x-[3]" />
    </div>
  </motion.article>
);

export const Supplies = () => (
  <section id="forniture" data-testid="supplies-section" className="relative bg-[#151517] py-28 lg:py-40">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <SectionHead label="Forniture" title={<>Materiali scelti <em className="italic text-[#e8c063]">con te,</em> posati da noi.</>}>
        <p className="mt-8 text-base md:text-lg text-[#c9c3b7] leading-relaxed max-w-xl">
          Ti accompagniamo nella scelta delle finiture e ci occupiamo direttamente di ordine, consegna e installazione.
          Dalle finiture all'arredamento: un'unica fornitura, un'unica garanzia.
        </p>
      </SectionHead>
      <div className="mt-20 grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
        {ITEMS.map((it, i) => <Card key={it.t} item={it} i={i} />)}
      </div>
    </div>
  </section>
);
